import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlertIcon, BuildingIcon, LandmarkIcon, LockIcon, ArrowRightIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionEyebrow } from './ui/SectionEyebrow';
const segments = [{
  icon: ShieldAlertIcon,
  title: 'Law Enforcement',
  outcomes: ['Manage internal and external requests in one place', 'Streamline inter-agency information sharing', 'Reduce administrative overhead across units']
}, {
  icon: BuildingIcon,
  title: 'Fusion Centers',
  outcomes: ['Handle high-volume external requests at scale', 'Standardize reporting across partner agencies', 'Track turnaround times in real time']
}, {
  icon: LandmarkIcon,
  title: 'Federal & State',
  outcomes: ['Coordinate requests across jurisdictions securely', 'Maintain a complete audit history', 'Deploy on compliant, US-hosted infrastructure']
}, {
  icon: LockIcon,
  title: 'Corporate Security',
  outcomes: ['Centralize internal investigation requests', 'Protect critical infrastructure and assets', 'Align with enterprise compliance requirements']
}];
export function SolutionsSegments() {
  return <section id="solutions" className="py-24 bg-iris-surface" data-id="element-266">
      <Container data-id="element-267">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-268">
          <SectionEyebrow text="Built For Your Mission" className="justify-center mb-4" data-id="element-269" />
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white" data-id="element-270">
            ONE PLATFORM. EVERY MISSION.
          </h2>
          <p className="text-iris-muted text-lg mt-6" data-id="element-271">
            IRIS adapts to the way your agency works — capabilities are not
            limited to any single sector.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-272">
          {segments.map((segment, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-iris-black border border-iris-border p-8 flex flex-col h-full group" data-id="element-273">
              <div className="flex items-center gap-4 mb-6" data-id="element-274">
                <div className="p-3 bg-iris-surface border border-iris-border group-hover:border-iris-green transition-colors" data-id="element-275">
                  <segment.icon className="w-6 h-6 text-iris-green" data-id="element-276" />
                </div>
                <h3 className="text-2xl font-display font-bold text-white uppercase tracking-wide" data-id="element-277">
                  {segment.title}
                </h3>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-278">
                {segment.outcomes.map((outcome, i) => <li key={i} className="flex items-start gap-2 text-iris-muted text-sm" data-id="element-279">
                    <span className="text-iris-green font-mono mt-0.5" data-id="element-280">›</span>
                    {outcome}
                  </li>)}
              </ul>

              <a href="#contact" className="inline-flex items-center gap-2 text-sm font-mono text-iris-text hover:text-iris-green transition-colors mt-auto" data-id="element-281">
                See use case <ArrowRightIcon className="w-4 h-4" data-id="element-282" />
              </a>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}